import { render } from "./TableTariffeGas.vue?vue&type=template&id=62790f68"
import script from "./TableTariffeGas.vue?vue&type=script&lang=js"
export * from "./TableTariffeGas.vue?vue&type=script&lang=js"

import "./TableTariffeGas.vue?vue&type=style&index=0&id=62790f68&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__